import React from 'react';
import { COLORS } from '../../styles/tokens';

// Strekikoner (24×24, currentColor) per massetype, i stil med Tabler Icons.
const PATHS = {
  // Spade
  soil: (
    <>
      <path d="M17 4l3 3" />
      <path d="M18.5 5.5l-8 8" />
      <path d="M8.276 11.284l4.44 4.44a.968 .968 0 0 1 0 1.369l-2.704 2.704a4.108 4.108 0 0 1 -5.809 -5.81l2.704 -2.703a.968 .968 0 0 1 1.37 0" />
    </>
  ),
  // Små steiner
  gravel: (
    <>
      <circle cx="7" cy="8" r="2.5" />
      <circle cx="15.5" cy="7" r="2" />
      <circle cx="11" cy="15" r="3" />
      <circle cx="18" cy="15.5" r="2" />
      <circle cx="5.5" cy="17" r="1.5" />
    </>
  ),
  // Kantete stein
  crushed_stone: (
    <>
      <path d="M4 15l3 -8l6 -3l7 5l-2 8l-9 3z" />
      <path d="M7 7l4 6l9 -4" />
      <path d="M11 13l-2 7" />
    </>
  ),
  // Sanddyner
  sand: (
    <>
      <path d="M3 18c3 -6 6 -6 9 0" />
      <path d="M9 18c3 -8 7 -8 12 0" />
      <path d="M3 18h18" />
    </>
  ),
  // Lastebil (bortkjøring: eldre massetype `removal` og produktet `bortkjoring`)
  removal: (
    <>
      <circle cx="7" cy="17" r="2" />
      <circle cx="17" cy="17" r="2" />
      <path d="M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5" />
    </>
  ),
  // Pakke
  other: (
    <>
      <path d="M12 3l8 4.5v9l-8 4.5l-8 -4.5v-9z" />
      <path d="M12 12l8 -4.5" />
      <path d="M12 12v9" />
      <path d="M12 12l-8 -4.5" />
    </>
  ),
};

// Samme beige rute for alle massetyper, som i designet. Ikonet viser typen.
const TONE = { bg: COLORS.surfaceHover, fg: COLORS.textDark };
const TONES = { default: TONE };

// Bortkjøring finnes både som eldre massetype («removal») og som produkt i katalogen («bortkjoring»)
const ICON_ALIASES = { bortkjoring: 'removal' };

export default function MassIcon({ massType, size = 44 }) {
  const tone = TONES.default;
  return (
    <div
      aria-hidden="true"
      style={{
        width: size, height: size, borderRadius: 12, flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: tone.bg, color: tone.fg,
      }}
    >
      <svg width={size * 0.55} height={size * 0.55} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        {PATHS[ICON_ALIASES[massType] ?? massType] ?? PATHS.other}
      </svg>
    </div>
  );
}
